import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Импорт компонентов
import MainKYC from './component/MainKYC';
import ExchangePage from './component/ExchangePage';
import ContactSection from './component/ContactSection';
import HeroSection from './component/HeroSection';
import ResetPassword from './pages/ResetPassword';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Features from './component/Features';
import Procedure from './component/Procedure';
import { FormProvider } from './FormContext';

/**
 * Компонент Pages управляет отображением контента на главной странице
 * и логикой плавного скролла.
 */
function Pages({ isAuthenticated, setIsAuthenticated }) {
  // Ссылки для плавного скролла
  const exchangeRef = useRef(null); // Ссылка на блок обмена
  const kycRef = useRef(null);      // Ссылка на блок регистрации

  /**
   * Функция плавного перехода к целевому блоку.
   * Если пользователь вошел — скроллим к обмену, иначе — к KYC.
   */
  const scrollToTarget = () => {
    if (isAuthenticated) {
      // Плавный скролл к ExchangePage
      exchangeRef.current?.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Плавный скролл к MainKYC
      kycRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="main-page">
      {/* Передаем состояние авторизации и функцию скролла в HeroSection */}
      <HeroSection 
        isAuthenticated={isAuthenticated} 
        setIsAuthenticated={setIsAuthenticated}
        onExchangeClick={scrollToTarget} 
      />
      
      <Features />
      <Procedure />
            
      {/* Отображение блоков в зависимости от статуса входа */}
      {isAuthenticated ? (
        <div ref={exchangeRef}>
          <ExchangePage />
        </div>
      ) : (
        <div ref={kycRef}>
          <MainKYC />
        </div>
      )}
      
      <ContactSection />
    </div>
  );
}

/**
 * Основной компонент приложения с роутингом и проверкой сессии.
 */
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Проверка наличия данных пользователя в localStorage при загрузке
  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      setIsAuthenticated(true);
    }
  }, []);

  return (
    <FormProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Главная страница */}
            <Route 
              path="/" 
              element={
                <Pages 
                  isAuthenticated={isAuthenticated} 
                  setIsAuthenticated={setIsAuthenticated} 
                />
              } 
            />
            
            {/* Страница политики конфиденциальности */}
            <Route path="https://bilpay.kg/oferta" element={<PrivacyPolicy />} />
            
            {/* Страница восстановления пароля */}
            <Route path="/reset-password/:token" element={<ResetPassword />} />
          </Routes>
        </div>
      </Router>
    </FormProvider>
  );
}

export default App;